import Route from "./routes/route";
function App() {
  return (
    <Route/>                           //Route Component holds all the routes available in the application
  );
}

export default App;
